module.exports = __webpack_public_path__ + "static/media/IMG_2239-min.e7422ce4.jpg";